export default "__VITE_ASSET__Dk31ITiC__"